import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods, FieldError } from "react-hook-form";
import { DONOR_PROVIDERS } from "../../constants";
import { useEffect, useState } from "react";

interface IProvider {
    control: UseFormMethods["control"];
    prefix?: string;
    error: FieldError | undefined;
    isOfferPort: boolean;
    isPrepaid: boolean;
    setProvider: any;
}

export const ProviderDropdown = (props: IProvider) => {
    const { t } = useTranslation(["portin", "validation"]);
    const { control, error, isOfferPort, setProvider, isPrepaid } = props;
    const [donorProviders, setDonorProviders] = useState<any[]>(
        DONOR_PROVIDERS.map((provider) => ({ value: provider.value, label: provider.label }))
    );

    useEffect(() => {
        if (!isOfferPort) {
            if (isPrepaid) {
                control.setValue("provider", "OT");
                setProvider("OT");
            } else {
                setDonorProviders(donorProviders.filter((item: any) => item.value !== "OT"));
            }
        }
    }, []);

    return (
        <Controller
            control={control}
            name={"provider"}
            rules={{
                required: t("validation:required"),
            }}
            render={(renderProps) => (
                <TextField
                    disabled={isOfferPort || isPrepaid}
                    fullWidth
                    id="provider"
                    inputRef={renderProps.ref}
                    label={`${t("portin:operator")} *`}
                    margin="dense"
                    name="provider"
                    select
                    value={renderProps.value || ""}
                    onChange={(event) => {
                        setProvider(event.target.value);
                        return renderProps.onChange(event);
                    }}
                    error={Boolean(error?.message)}
                    helperText={error?.message}
                >
                    {donorProviders.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
